import { useState, useEffect } from 'react';
import { useHover, useFocusWithin, useFocusManager } from 'react-aria';
export const useInitialPromptsAccessibility = ({
  shouldTrapFocus,
  onHoverChange
}) => {
  const [shouldContainFocus, setShouldContainFocus] = useState(shouldTrapFocus);
  const focusManager = useFocusManager();
  useEffect(() => {
    setShouldContainFocus(shouldTrapFocus);
  }, [shouldTrapFocus]);
  useEffect(() => {
    const handleKeyDown = event => {
      if (event.key === 'Escape') {
        var _focusManager$focusLa;
        onHoverChange(false);
        setShouldContainFocus(false);
        focusManager === null || focusManager === void 0 || (_focusManager$focusLa = focusManager.focusLast) === null || _focusManager$focusLa === void 0 || _focusManager$focusLa.call(focusManager);
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onHoverChange, focusManager]);
  const {
    hoverProps
  } = useHover({
    onHoverStart: () => onHoverChange(true),
    onHoverEnd: () => onHoverChange(false)
  });
  const {
    focusWithinProps
  } = useFocusWithin({
    onFocusWithinChange: isFocusWithin => {
      if (!isFocusWithin) {
        const activeElement = document.activeElement;
        if (activeElement instanceof HTMLElement) {
          activeElement.blur();
        }
      }
      onHoverChange(isFocusWithin);
      setShouldContainFocus(shouldTrapFocus && isFocusWithin);
    }
  });
  const interactionProps = Object.assign({}, hoverProps, focusWithinProps);
  return {
    interactionProps,
    shouldContainFocus
  };
};